import React from 'react'
import { TrophyMemoryCardLoading } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryCardLoading'
import styles from './TrophyMemoriesLoading.module.scss'

export const TrophyMemoriesLoading: React.FC = () => {
  const numCards = 5

  const cards = Array.from(
    Array(numCards).keys()
  ).map((index) => <TrophyMemoryCardLoading key={ index }/>)

  return (
    <div className={ styles.trophyMemoriesLoading__container }>
      { cards }
    </div>
  )
}
